<template>
    <div v-if="props.uiMode === 'light'" :style="cssBinds[0][0]">
        <v-row dense>
            <v-col cols="12" :style="cssBinds[0][1]">
                {{ getPeriodType() }}
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" :style="cssBinds[0][2]">
                {{ getPeriodText() }}
            </v-col>
        </v-row>
    </div>
    <div v-else :style="cssBinds[1][0]">
        <v-row dense>
            <v-col cols="12" :style="cssBinds[1][1]">
                {{ getPeriodType() }}
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" :style="cssBinds[1][2]">
                {{ getPeriodText() }}
            </v-col>
        </v-row>
    </div>
</template>

<script setup>
import { onMounted, onUpdated } from "vue";
import { faLog, getSearchPeriodType } from "../common/faCommon.js";

const FN = "[SearchPeriod] ";
const props = defineProps({
    uiMode: {
        type: String,
        required: true,
    },
    period: {
        type: Object,
        required: true,
    },
});

onUpdated(() => {
    faLog(0, FN + "[DeviceData] [onUpdated]");
});

onMounted(() => {
    faLog(0, FN + "[DeviceData] [onMounted]");
});

const getPeriodType = () => {
    return getSearchPeriodType(props.period.type);
};

const getPeriodText = () => {
    return props.period.fromDt + " ~ " + props.period.toDt;
};

const cssBinds = [
    [
        {
            width: "calc(100% - 10px)",
            // height: "calc(100% - 10px)",
            overflowY: "auto",
            overflowX: "auto",
            marginLeft: "5px",
            marginRight: "5px",
            marginTop: "5px",
            marginBottom: "5px",
            borderColor: "#cccccc",
            borderRadius: "5px",
            borderStyle: "solid",
            // marginTop: "0px",
        },
        {
            textAlign: "left",
            color: "#01579b",
            fontSize: "1rem",
            fontWeight: "normal",
            marginLeft: "10px",
            marginRight: "0px",
            marginTop: "5px",
            marginBottom: "-5px",
        },
        {
            textAlign: "left",
            color: "black",
            fontSize: "1rem",
            fontWeight: "normal",
            marginLeft: "10px",
            marginRight: "0px",
            marginTop: "-5px",
            marginBottom: "5px",
        }
    ],
    [
        {
            width: "calc(100% - 10px)",
            // height: "calc(100% - 10px)",
            overflowY: "auto",
            overflowX: "auto",
            marginLeft: "5px",
            marginRight: "5px",
            marginTop: "5px",
            marginBottom: "5px",
            borderColor: "#505050",
            borderRadius: "5px",
            borderStyle: "solid",
            // marginTop: "0px",
        },
        {
            textAlign: "left",
            color: "#55c5f8",
            fontSize: "1rem",
            fontWeight: "normal",
            marginLeft: "10px",
            marginRight: "0px",
            marginTop: "5px",
            marginBottom: "-5px",
        },
        {
            textAlign: "left",
            color: "white",
            fontSize: "1rem",
            fontWeight: "normal",
            marginLeft: "10px",
            marginRight: "0px",
            marginTop: "-5px",
            marginBottom: "5px",
        }
    ],
];

</script>

